import * as apiContract from '@/api/contract'
import { formatDateKanji, applicationNoIssuing, commonErrorMessage } from '@/util/common'
import * as _ from 'lodash'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    options: {
      payment: null,
      charge_name: null
    },
    calculation: [],
    users_to_disable: [],
    cancellationList: [],
    visiblePopup: null
  }
  return defaults
}

const cancellation = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    edited: state => _.filter(state.lists, list => list.edited && list.cancellation > 0),
    getCancelList: (state, getters) => _.map(getters.edited, list => {
      return {
        code: list.code,
        num: list.cancellation,
        name: list.name,
        afterNum: list.license_number - list.cancellation, // 解約数を引いた後のライセンス数
        using_license: list.using_license
      }
    }),
    // 解約後のライセンス数に対して利用者に割り当てているライセンス数が超過するリスト
    getLicenseShortage: (state) => _.filter(state.calculation, list => list.afterNum < list.using_license.length)
  },
  mutations: {
    setDefaultLists(state, value) {
      state.lists = value
    },
    setCancellation(state, { index, selected }) {
      const prev = state.lists[index]
      prev.cancellation = selected
      prev.edited = true
      state.lists.splice(index, 1, prev)
    },
    resetCancellation(state, index) {
      const prev = state.lists[index]
      prev.cancellation = 0
      prev.edited = false
      state.lists.splice(index, 1, prev)
    },
    allCancellation(state, index) {
      const prev = state.lists[index]
      prev.cancellation = prev.license_number
      prev.edited = true
      state.lists.splice(index, 1, prev)
    },
    setCalculation(state, cancellationList) {
      state.calculation = cancellationList
    },
    setCancellationConfirm(state, cancellationList) {
      state.cancellationList = cancellationList
    },
    setDisableUser(state, list) {
      state.users_to_disable = list
    },
    // buyPurchase(state, index) {
    //   const prev = state.lists[index]
    //   prev.edited = true
    //   state.lists.splice(index, 1, prev)
    // },
    // setCalculation(state, purchaseList) {
    //   state.calculation = purchaseList
    // },
    // setPurchaseComplete(state, cancellationList) {
    //   state.cancellationList = cancellationList
    // },
    setVisiblePopup(state, value) {
      state.visiblePopup = value
    },
    resetAllState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    // // 商品のリストを生成
    async setDefaultLists({ commit, rootGetters }) {
      const signedPackageProduct = rootGetters['contractPack/signedPackageProduct']
      const lists = _.map(signedPackageProduct, product => {
        product.cancellation = 0
        product.edited = false
        return product
      })
      await commit('setDefaultLists', lists)
    },
    // // 解約数を指定
    changeCancellation({ commit }, { index, selected }) {
      commit('setCancellation', { index, selected })
    },
    // リセットボタン押下
    resetCancellation({ commit }, index) {
      commit('resetCancellation', index)
    },
    // ライセンス解約ボタン押下
    allCancellation({ commit }, index) {
      commit('allCancellation', index)
    },
    // 解約情報をセット
    async setCalculation({ commit, getters }) {
      const cancelList = getters.getCancelList
      await commit('setCalculation', cancelList)
    },
    async cancellationConfirm({ state, commit, getters }) {

      // 解約後のライセンス数に対して利用者に割り当てているライセンス数が超過するリストを取得
      const shortageList = getters.getLicenseShortage

      const isLicenseNumOver = (shortageList.length > 0)

      // 次の画面遷移先を決める
      const nextPopup = isLicenseNumOver ? 'userInput' : 'confirm'
      if (isLicenseNumOver) {
        // ライセンスを付与されている利用者数が次年度継続ライセンス数の枠内に収まっていない場合
        commit('setVisiblePopup', nextPopup)
      } else {
        // ライセンスを付与されている利用者数が次年度継続ライセンス数の枠内に収まっている場合

        // APIに渡すパラメータを作成
        const calculation = _.cloneDeep(state.calculation)
        const paramData = _.map(calculation, list => {
          delete list.afterNum
          delete list.using_license
          delete list.name

          return list
        })

        const params = {
          type: 3, // 解約予約確認
          data: paramData
        }

        await apiContract
          .applyProducts(params)
          .then((response) => {
            const { data } = response
            if (data.status === 0) {
              commit('setCancellationConfirm', data)
              commit('setVisiblePopup', nextPopup)
            } else {
              commonErrorMessage(response)
            }
            return data
          })
      }
    },
    async cancellationUserConfirm({ state, commit }) {

      // APIに渡すパラメータを作成
      const calculation = _.cloneDeep(state.calculation)
      const paramData = _.map(calculation, list => {
        delete list.afterNum
        delete list.using_license

        return list
      })

      const params = {
        type: 4, // 解約予約確認（無効にするアカウント情報）
        data: paramData,
        users_to_disable: state.users_to_disable
      }

      await apiContract
        .applyProducts(params)
        .then((response) => {
          const { data } = response
          if (data.status === 0) {
            commit('setCancellationConfirm', data)
            commit('setVisiblePopup', 'confirm')
          } else {
            commonErrorMessage(response)
          }
          return data
        })
    },
    closeUserInput({ commit }) {
      commit('setVisiblePopup', null)
    },
    submitUserInput({ commit }, lists) {
      commit('setDisableUser', lists)
    },
    closeConfirm({ commit }) {
      commit('setVisiblePopup', null)
    },
    async submitConfirm({ state, commit }) {
      // APIに渡すパラメータを作成
      const calculation = _.cloneDeep(state.calculation)
      const paramData = _.map(calculation, list => {
        delete list.afterNum
        delete list.using_license

        return list
      })

      const params = {
        type: 5, // 解約実行
        data: paramData,
        users_to_disable: state.users_to_disable
      }

      await apiContract
        .applyProducts(params)
        .then((response) => {
          const { data } = response
          if (data.status === 0) {
            commit('setCancellationConfirm', data)
            commit('setVisiblePopup', 'complete')
          } else {
            commonErrorMessage(response)
          }
          return data
        })
    },
    closeComplete({ commit }) {
      commit('setCancellationConfirm', null)
      commit('setVisiblePopup', null)
    },
    // async purchaseComplete({ state, commit }) {
    //   const params = {
    //     type: 2, // 購入完了
    //     data: state.calculation,
    //     payment: state.options.payment,
    //     charge_name: state.options.charge_name
    //   }
    //   await apiContract
    //     .applyProducts({ params })
    //     .then((response) => {
    //       const { data } = response
    //       if (data.status === 0) {
    //         commit('setPurchaseComplete', data)
    //       }
    //     })
    // }
    resetAllState({ commit }) {
      commit('resetAllState')
    }
  }
}

export default cancellation
